import { useState } from "react";

export const FightRounds = ({ rounds, corner: ours = "" }) => {
  const corners = [...new Set(rounds.map((r) => r.corner).filter(Boolean))];
  const [corner, setCorner] = useState(corners.includes(ours) ? ours : corners[0] || "");
  const shown = rounds.filter((r) => !corner || r.corner === corner);
  return (
    <section className="px-4 sm:px-6 py-4 border-t border-border" data-testid="film-rounds">
      <div className="flex flex-wrap items-center gap-2 mb-3">
        <h3 className="font-heading font-bold mr-auto">Combinations by round</h3>
        {corners.map((c) => (
          <button key={c} data-testid={`film-rounds-corner-${c}`} onClick={() => setCorner(c)}
            className={`text-xs px-3 py-1.5 border capitalize ${corner === c ? "bg-foreground text-background" : "border-border"}`}>{`${c} corner`}</button>
        ))}
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {shown.map((r) => (
          <div key={`${r.round}-${r.corner}`} className="border border-border p-3" data-testid={`film-round-${r.round}-${r.corner}`}>
            <p className="text-xs uppercase tracking-widest text-muted-foreground">{`Round ${r.round} · ${r.corner || "corner unknown"}${r.fighter ? ` · ${r.fighter}` : ""}`}</p>
            <p className="font-heading text-xl font-black tabular-nums mt-1">{`${r.totals?.thrown || 0} thrown${r.totals?.landed ? ` · ${r.totals.landed} landed` : ""}`}</p>
            <ul className="mt-2 text-sm space-y-1">
              {(r.combos || []).slice(0, 8).map((c) => (
                <li key={c.sequence} className="flex justify-between gap-3"><span className="capitalize">{c.sequence}</span><span className="tabular-nums text-muted-foreground">{`${c.thrown}×${c.landed ? ` · ${c.landed} landed` : ""}`}</span></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-muted-foreground mt-2">Counts read from video by AI · estimates to review, not official punch stats.</p>
    </section>
  );
};
